import { notificationManager } from "@/domains/notifications/services/notification-manager";
import type { UserNotification } from "@/domains/notifications/types";
import type { NotificationHandler } from "../types";

export class DefaultNotificationHandler implements NotificationHandler {
  handleNotification(notification: UserNotification): void {
    notificationManager.handleNotification(notification);
    this.triggerNotificationEvent(notification);
  }

  triggerNavigationEvent(url: string, notificationId: string, data: any): void {
    window.dispatchEvent(
      new CustomEvent("push-notification-navigation", {
        detail: { url, notificationId, data },
      })
    );
  }

  private triggerNotificationEvent(notification: UserNotification): void {
    window.dispatchEvent(
      new CustomEvent("push-notification-received", {
        detail: notification,
      })
    );
  }
}
